import { render } from "./CallToActionButtons.vue?vue&type=template&id=6204e746"
import script from "./CallToActionButtons.vue?vue&type=script&lang=js"
export * from "./CallToActionButtons.vue?vue&type=script&lang=js"

import "./CallToActionButtons.vue?vue&type=style&index=0&id=6204e746&lang=css"
script.render = render

export default script